let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lRSnz")).then(() => parcelRequire('dKfJw'));